var _dec, _class, _class2, _temp;
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import * as React from 'react';
import { Form } from '4finance-onion-form';
import translate from '4finance-translate';
import injectStyles from '4finance-components';
import { SubmitButton } from '../../fields';
import styles from './RecoverChoice.jss';
var EmailRecoveryIcon = function EmailRecoveryIcon(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M6 2a4 4 0 0 0-4 4v61a4 4 0 0 0 4 4h67a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4H6zm0-2h67a6 6 0 0 1 6 6v61a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6z",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M20 31a1 1 0 0 0-1 1v25a1 1 0 0 0 1 1h39a1 1 0 0 0 1-1V32a1 1 0 0 0-1-1H20zm0-2h39a3 3 0 0 1 3 3v25a3 3 0 0 1-3 3H20a3 3 0 0 1-3-3V32a3 3 0 0 1 3-3z",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M18.464 34.741l-.928 1.772 21.036 11.019a2 2 0 0 0 1.856 0l21.036-11.02-.928-1.77L39.5 45.76 18.464 34.741z",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M1 17h77v-2H1zM19 8.5c0 1.382-1.118 2.5-2.5 2.5A2.499 2.499 0 0 1 14 8.5C14 7.118 15.118 6 16.5 6S19 7.118 19 8.5M12 8.5c0 1.382-1.118 2.5-2.5 2.5A2.499 2.499 0 0 1 7 8.5C7 7.118 8.118 6 9.5 6S12 7.118 12 8.5"
  })));
};
EmailRecoveryIcon.defaultProps = {
  viewBox: "0 0 79 73",
  xmlns: "http://www.w3.org/2000/svg"
}; // asd eslint-disable-line import/namespace, import/default

var PhoneRecoveryIcon = function PhoneRecoveryIcon(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M4 2a2 2 0 0 0-2 2v65a2 2 0 0 0 2 2h38a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm0-2h38a4 4 0 0 1 4 4v65a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M20.65 41.877a2 2 0 0 1 1.077-.092C22.47 41.928 23.23 42 24 42c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12c0 2.504.766 4.888 2.174 6.89a2 2 0 0 1 .302 1.645l-1.593 6.25 7.767-2.908zM10 48l2.538-9.96A13.936 13.936 0 0 1 10 30c0-7.732 6.268-14 14-14s14 6.268 14 14-6.268 14-14 14c-.906 0-1.791-.086-2.65-.25L10 48z",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M27 61.5c0 1.935-1.565 3.5-3.5 3.5a3.498 3.498 0 0 1-3.5-3.5c0-1.935 1.565-3.5 3.5-3.5s3.5 1.565 3.5 3.5"
  })));
};
PhoneRecoveryIcon.defaultProps = {
  viewBox: "0 0 46 73",
  xmlns: "http://www.w3.org/2000/svg"
}; // eslint-disable-line import/namespace, import/default

var EmailRecoveryMobile = function EmailRecoveryMobile(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M3 2a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h33a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3zm0-2h33a3 3 0 0 1 3 3v22a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z"
  }), React.createElement("path", {
    d: "M1.642 4.833L.722 6.61l17.858 9.255a2 2 0 0 0 1.84 0l17.858-9.255-.92-1.776L19.5 14.088 1.642 4.833z"
  })));
};
EmailRecoveryMobile.defaultProps = {
  viewBox: "0 0 39 28",
  xmlns: "http://www.w3.org/2000/svg"
}; // eslint-disable-line import/namespace, import/default

var Arrow = function Arrow(props) {
  return React.createElement("svg", props, React.createElement("defs", null, React.createElement("path", {
    d: "M299.79 279.907l-6.703-7.052a.323.323 0 0 1 0-.441l1.257-1.323a.286.286 0 0 1 .419 0l5.237 5.51 5.237-5.51a.286.286 0 0 1 .42 0l1.256 1.323a.323.323 0 0 1 0 .44l-6.704 7.053a.283.283 0 0 1-.418 0z",
    id: "a"
  })), React.createElement("use", {
    transform: "rotate(-90 18.5 289)",
    xlinkHref: "#a",
    fillRule: "evenodd"
  }));
};
Arrow.defaultProps = {
  viewBox: "0 0 10 15",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}; // eslint-disable-line import/namespace, import/default

var RecoverChoice = (_dec = injectStyles(styles), translate(_class = _dec(_class = (_temp = _class2 = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(RecoverChoice, _React$PureComponent);
  function RecoverChoice() {
    _classCallCheck(this, RecoverChoice);
    return _possibleConstructorReturn(this, _getPrototypeOf(RecoverChoice).apply(this, arguments));
  }
  _createClass(RecoverChoice, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        setEmailRecover = _this$props.setEmailRecover,
        setPhoneRecover = _this$props.setPhoneRecover,
        classes = _this$props.classes,
        cnt = _this$props.cnt,
        msg = _this$props.msg;
      return React.createElement("div", null, React.createElement("h1", {
        className: classes.title
      }, cnt('recoverChoice.title')), React.createElement(Form, {
        name: "recoverChoice"
      }, React.createElement("div", {
        className: classes.choice,
        onClick: setEmailRecover
      }, React.createElement("div", {
        className: classes.icon
      }, React.createElement(EmailRecoveryIcon, {
        className: "desktop"
      }), React.createElement(EmailRecoveryMobile, {
        className: "mobile"
      })), React.createElement("div", {
        className: classes.choiceDescr
      }, React.createElement("h2", {
        className: classes.subtitle
      }, cnt('recoverChoice.emailSubtitle')), React.createElement("p", {
        className: classes.description
      }, cnt('recoverChoice.emailDescription')), React.createElement(SubmitButton, {
        onClick: setEmailRecover
      }, msg('recoverChoice.emailButtonText'))), React.createElement("div", {
        className: classes.arrow
      }, React.createElement(Arrow, {
        className: "mobile"
      }))), React.createElement("div", {
        className: classes.choice,
        onClick: setPhoneRecover
      }, React.createElement("div", {
        className: classes.icon
      }, React.createElement(PhoneRecoveryIcon, null)), React.createElement("div", {
        className: classes.choiceDescr
      }, React.createElement("h2", {
        className: classes.subtitle
      }, cnt('recoverChoice.phoneSubtitle')), React.createElement("p", null, cnt('recoverChoice.phoneDescription')), React.createElement(SubmitButton, {
        onClick: setPhoneRecover
      }, msg('recoverChoice.phoneButtonText'))), React.createElement("div", {
        className: classes.arrow
      }, React.createElement(Arrow, {
        className: "mobile"
      })))));
    }
  }]);
  return RecoverChoice;
}(React.PureComponent), _defineProperty(_class2, "styleRoot", 'RecoverChoice'), _defineProperty(_class2, "defaultProps", {
  classes: {},
  cnt: function cnt() {
    return '';
  },
  msg: function msg() {
    return '';
  }
}), _temp)) || _class) || _class);
export { RecoverChoice as default };